import {
  GOOGLE_ADS_CAMPAIGN_STATUS,
  GoogleAdsCampaignConnectionStatus,
} from '../../../../../../services/exports/Constants';

export default {
  title: 'Google Ads',
  search: {
    placeholder: 'Søg efter ID, navn eller virksomhed',
  },
  filters: {
    connection_statuses: {
      placeholder: 'Forbindelsesstatus',
      options: {
        [GoogleAdsCampaignConnectionStatus.Connected]: 'Forbundet',
        [GoogleAdsCampaignConnectionStatus.NotConnected]: 'Ikke forbundet',
      },
    },
  },
  columns: {
    name: 'Navn',
    company: 'Virksomhed',
    connected: 'Forbundet',
    action: 'Handling',
    details: 'Detaljer',
    address: 'Adresse',
    status: 'Status',
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Ikke angivet',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Aktiv',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Sat på pause',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Ukendt',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Fjernet',
  },
};
